import { useTranslation } from 'react-i18next'
import { Button, Typography } from '@mui/material'
import { Form, useFormikContext } from 'formik'

import { UsersSearchInput } from './user-search-input.component'
import { FormSelect, HelperWrapper } from 'src/components'
import { ISortSelectOption } from 'src/components/filter/types/filter.types'
import { EAccountRoles, IAccountUserInviteFormDto } from 'src/types'

import { useStyles } from '../styles'

const accountRolesSelect: ISortSelectOption[] = Object.entries(EAccountRoles).map(
  ([label, value]) => ({ label, value }),
)
const InviteForm = () => {
  const [t] = useTranslation()
  const classes = useStyles()
  const { errors, values, handleChange, isSubmitting } =
    useFormikContext<IAccountUserInviteFormDto>()

  return (
    <Form className={classes.inviteForm}>
      <Typography className={classes.inviteModalTitle} component="h2">
        <HelperWrapper t="account-users-invite-title" />
      </Typography>
      <div className={classes.formInputsWrapper}>
        <FormSelect
          noClear
          inputName="role"
          handleChange={handleChange}
          items={accountRolesSelect}
          selectName={t('account-users-change-role-roles-select.v')}
          value={values.role}
          errorText={errors.role && <HelperWrapper t={errors.role} />}
        />
        <UsersSearchInput />
      </div>
      <div>
        <Button disabled={isSubmitting} size="large" type="submit" variant="contained">
          <HelperWrapper t="account-users-invite-button-text" />
        </Button>
      </div>
    </Form>
  )
}

export { InviteForm }
